module.exports = __webpack_public_path__ + "img/cr-fishing.fcd7ab95.jpg";